import React, { useState } from "react";
import axios from "axios";
import "../styles/Edit.css";
import backendUrl from "../BackendUrl";

const ModelUtilitySpecsManager = ({ modelId, utilitySpecs, onUpdate }) => {
  const [isCanvasOpen, setCanvasOpen] = useState(false);
  const [selectedSpecIndex, setSelectedSpecIndex] = useState(null);
  const [specData, setSpecData] = useState({
    spec: "",
    specDesc: [],
    bar: false,
  });
  const [isNewSpec, setIsNewSpec] = useState(false);
  const adminToken = localStorage.getItem("adminToken");

  const openCanvas = () => setCanvasOpen(true);

  const closeCanvas = () => {
    setCanvasOpen(false);
    setSelectedSpecIndex(null);
    setSpecData({ spec: "", specDesc: [], bar: false });
    setIsNewSpec(false);
  };

  const handleSelectChange = (e) => {
    const value = e.target.value;

    if (value === "new") {
      setIsNewSpec(true);
      setSelectedSpecIndex(null);
      setSpecData({ spec: "", specDesc: [], bar: false });
    } else {
      const index = parseInt(value, 10);
      const existingSpec = utilitySpecs[index];

      setIsNewSpec(false);
      setSelectedSpecIndex(index);
      setSpecData({
        spec: existingSpec.spec || "",
        specDesc: Array.isArray(existingSpec.specDesc)
          ? existingSpec.specDesc
          : [],
        bar: existingSpec.bar || false,
      });
    }
  };

  const handleInputChange = (e, descIndex = null) => {
    const { name, value, checked, type } = e.target;

    if (name === "spec") {
      setSpecData((prev) => ({ ...prev, spec: value }));
    } else if (name === "bar") {
      setSpecData((prev) => ({ ...prev, bar: checked }));
    } else {
      const updatedDesc = [...specData.specDesc];
      updatedDesc[descIndex] = value;
      setSpecData((prev) => ({ ...prev, specDesc: updatedDesc }));
    }
  };

  const addDescriptionField = () => {
    setSpecData((prev) => ({
      ...prev,
      specDesc: [...prev.specDesc, ""],
    }));
  };

  const removeDescriptionField = (index) => {
    setSpecData((prev) => ({
      ...prev,
      specDesc: prev.specDesc.filter((_, i) => i !== index),
    }));
  };

  const handleSubmit = async () => {
    if (!specData.spec.trim()) {
      alert("Spec name is required.");
      return;
    }

    try {
      let response;
      let updatedSpecs;

      if (isNewSpec) {
        const newSpec = {
          spec: specData.spec,
          specDesc: specData.specDesc,
          bar: specData.bar,
        };

        response = await axios.post(
          `${backendUrl}/api/vehicles/add-model-utility-spec/${modelId}`,
          { utilitySpecs: [newSpec] },
          { headers: { Authorization: `Bearer ${adminToken}` } }
        );

        updatedSpecs = response.data.model.utilitySpecs;
      } else {
        updatedSpecs = utilitySpecs.map((s, index) =>
          index === selectedSpecIndex ? specData : s
        );

        const specId = utilitySpecs[selectedSpecIndex]._id;

        response = await axios.put(
          `${backendUrl}/api/vehicles/update-model-utility-spec/${modelId}/${specId}`,
          { utilitySpecs: updatedSpecs },
          { headers: { Authorization: `Bearer ${adminToken}` } }
        );

        updatedSpecs = response.data.model.utilitySpecs;
      }

      onUpdate(updatedSpecs);
      closeCanvas();
      alert(isNewSpec ? "Spec added!" : "Spec updated!");
    } catch (err) {
      console.error(err);
      alert("Failed to save spec.");
    }
  };

  const handleSpecDelete = async () => {
    if (!window.confirm("Delete this spec?")) return;

    try {
      const specId = utilitySpecs[selectedSpecIndex]._id;

      const response = await axios.delete(
        `${backendUrl}/api/vehicles/delete-model-utility-spec/${modelId}/${specId}`,
        { headers: { Authorization: `Bearer ${adminToken}` } }
      );

      onUpdate(response.data.model.utilitySpecs);
      closeCanvas();
      alert("Spec deleted.");
    } catch (err) {
      console.error(err);
      alert("Failed to delete spec.");
    }
  };

  return (
    <div>
      <button type="button" onClick={openCanvas}>
        Edit Utility Specs
      </button>

      {isCanvasOpen && (
        <div className="canvas-overlay">
          <div className="canvas">
            <h2>{isNewSpec ? "Add Utility Spec" : "Edit Utility Spec"}</h2>

            <label>
              Select Spec:
              <select
                onChange={handleSelectChange}
                value={selectedSpecIndex ?? ""}
              >
                <option value="">Select a spec...</option>
                {utilitySpecs.map((spec, index) => (
                  <option key={index} value={index}>
                    {spec.spec || `Spec ${index + 1}`}
                  </option>
                ))}
                <option value="new">+ Add New Spec</option>
              </select>
            </label>

            {(isNewSpec || selectedSpecIndex !== null) && (
              <>
                <label>
                  Spec Name:
                  <input
                    type="text"
                    name="spec"
                    value={specData.spec}
                    onChange={handleInputChange}
                  />
                </label>

                <label className="toggle">
                  <input
                    type="checkbox"
                    name="bar"
                    checked={specData.bar}
                    onChange={handleInputChange}
                  />
                  <span>Display as Bar</span>
                </label>

                <h3>Descriptions</h3>
                {specData.specDesc.map((desc, index) => (
                  <div key={index} className="desc-input">
                    <input
                      type="text"
                      value={desc}
                      onChange={(e) => handleInputChange(e, index)}
                    />
                    <button
                      type="button"
                      onClick={() => removeDescriptionField(index)}
                    >
                      Delete
                    </button>
                  </div>
                ))}

                <button type="button" onClick={addDescriptionField}>
                  + Add Description
                </button>

                <div className="canvas-buttons">
                  <button type="button" onClick={handleSubmit}>
                    {isNewSpec ? "Add Spec" : "Update Spec"}
                  </button>

                  {!isNewSpec && selectedSpecIndex !== null && (
                    <button type="button" onClick={handleSpecDelete}>
                      Delete Spec
                    </button>
                  )}

                  <button type="button" onClick={closeCanvas}>
                    Cancel
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ModelUtilitySpecsManager;